export default "__VITE_ASSET__c58842d9__"